<script>

///Ultima alteração: 27/05/2020
///Alterado por: Allinne

	export let realty		= null;
	export let type			= null;
	export let style 		= "";

	const defaultValues = {
		'Id': {
			titulo: 	'Cod',
			name:   	'cod',
			info:   	realty.ReferenceId,
			icon:   	'<i class="fas fa-hashtag"></i>',
			pluralize: 	false
		},
		'Bathrooms': {
			titulo:		'banheiro',
			name:   	'banheiros',
			info:   	realty.Bathrooms,
			icon:   	'<i class="fas fa-shower"></i>'
		},
		'Bedrooms': {
			titulo: 	'dorm.',
			name:   	'dorm',
			info:   	realty.Bedrooms,
			icon:   	'<i class="fas fa-bed"></i>',
			pluralize: 	false
		},
		'Area': {
			titulo: 	'área',
			name:   	'area',
			info:   	realty.Area > 0 ? realty.Area + "m²" : 0,
			icon:   	'<i class="fas fa-draw-polygon"></i>',
		},
		'LotArea': {
			titulo: 	'área total',
			name:   	'areatotal',
			info:   	realty.LotArea > 0 ? realty.LotArea + "m²" : 0,
			icon:   	'<i class="fas fa-draw-square"></i>',
		},
		'ParkingSpots': {
			titulo: 	'vaga',
			name:   	'vagas',
			info:   	realty.ParkingSpots,
			icon:   	'<i class="fas fa-car-side"></i>',
		},
		'Furnished': {
			titulo: 	'mobiliado',
			name:   	'Mobiliado',
			info:   	realty.Furnished,
			icon:   	'<i class="fas fa-couch"></i>',
		}
	};

	export let titulo		= defaultValues[type] ? defaultValues[type].titulo : '';
	export let name			= defaultValues[type] ? defaultValues[type].name : '';
	export let info			= defaultValues[type] ? defaultValues[type].info : '';
	export let icon			= defaultValues[type] ? defaultValues[type].icon : '';
	export let pluralize	= defaultValues[type] ? defaultValues[type].pluralize : true;
</script>

{#if info != null && info != ""}
	<div class="caracteristica-box hide-{info} caracteristica-box--{style}">
		<div class="caracteristica caracteristica--{name}">
			<div class="icon">{@html icon}</div>
			<div class="titulo">{titulo}{#if info > 1 && pluralize != false}s{/if}</div>
			<div class="info">{info}</div>
		</div>
	</div>
{/if}

<style type="text/sass">
@import 'public/assets/sass/variables.sass'

.caracteristica-box 
	flex: 1
	.caracteristica 
		display: grid
		grid-gap: 0 5px
		grid-template-areas: "icon icon" "info titulo"
		width: fit-content
		margin: auto
		padding: 5px
		.info
			grid-area: info
		.titulo
			grid-area: titulo
		.icon 
			grid-area: icon
			color: $color-primary
		.info, .titulo
			white-space: nowrap
		&.caracteristica--cod
			grid-template-areas: "icon icon" "titulo info"
		&.caracteristica--area
			.titulo
				display: none
	/* Styles */ 
	&.caracteristica-box--list
		.caracteristica
			grid-template-areas: "icon" "info"
			.titulo 
				display: none
</style>